
import { searchProjects } from '@/helpers/search'
import { ESearchPageType, EProjectType } from '@/helpers/enums'

export default {
  name: 'ProjectVmsId',
  auth: false,
  data() {
    return { projectData: null, loading: true }
  },
  async fetch() {
    const { app, route, store, error } = this.$nuxt.context
    try {
      const { results } = await searchProjects({
        pageSize: 1,
        context: app,
        type: EProjectType.PUBLIC,
        typedQuery: ESearchPageType.VMS_ID,
        route
      })

      const project = results && results.length ? results[0] : null

      if (
        project &&
        project?.clientName === store.state.clientContext.name &&
        decodeURIComponent(route.params.id) === project.vmsJobId
      ) {
        this.projectData = project
      }
    } catch ({ response }) {
      const statusCode = response ? response.status : '400'
      const message = response ? response.statusText : 'Bad Request'
      error({
        statusCode,
        message
      })
    }
  },
  mounted() {
    this.loading = false

    if (this.projectData) {
      this.$router.push(this.$link.project(this.projectData, this.$route.query))
    } else {
      this.$router.push(this.$link.projectSearch(this.$route.query))
    }
  }
}
